export const DEFAULT_BOT_AVATAR_URL = '/brand-assets/logo_icon.png';
